import React from "react";
import { Loader } from 'rsuite';

const ShowLoader = () => {
  return (
    <div className="loader">
      <Loader backdrop content="loading..." vertical size="md"/>
    </div>
  );
};

export default ShowLoader;
